// src/pages/warehouses/Warehouses.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WarehousesTable from "../../components/warehouses/WarehousesTable";

const Warehouses = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <WarehousesTable />
    </WrapperSection>
);

export default Warehouses;
